import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route change AND on page load/refresh.
// If URL contains a hash (#section), scroll to that element instead.
//
// Disabilita anche la "scroll restoration" del browser, così su refresh
// la pagina riparte SEMPRE dall'alto (non dalla posizione precedente).
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Una sola volta al mount: forza manual scroll restoration.
        if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
    }, []);

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname, hash]);
    return null;
}
